export default __webpack_public_path__ + "static/media/Cycle_Yoga.b87cf806.svg";